import { render, staticRenderFns } from "./faxForm.vue?vue&type=template&id=2b845234&scoped=true&"
import script from "./faxForm.vue?vue&type=script&lang=js&"
export * from "./faxForm.vue?vue&type=script&lang=js&"
import style0 from "./faxForm.vue?vue&type=style&index=0&id=2b845234&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b845234",
  null
  
)

export default component.exports